import mutations, { getDefaultState } from './mutations'
import actions from './actions'

export const implemento = {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
}
